'use client';
import React, { useEffect, useRef, useState } from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

const slides = [
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_16e75453d-1767738122182.png",
  alt: 'Construction workers pouring concrete foundation at building site, dim industrial lighting, dark steel forms, deep shadows'
},
{
  src: "https://images.unsplash.com/photo-1733078083073-df240b8d29be",
  alt: 'Concrete being poured from mixer truck at construction site, overcast sky, wet concrete surface, low-key dramatic atmosphere'
},
{
  src: "https://img.rocket.new/generatedImages/rocket_gen_img_1c19ffa23-1768568206846.png",
  alt: 'Close-up of freshly poured concrete slab being leveled by workers, moody industrial environment, dark tones'
}];


const stats = [
{ icon: 'WrenchScrewdriverIcon', value: '15+', label: 'ЛЕТ НА РЫНКЕ' },
{ icon: 'CubeIcon', value: '350+', label: 'ОБЪЕКТОВ СДАНО' },
{ icon: 'CheckBadgeIcon', value: '100%', label: 'ГАРАНТИЯ' }];


export default function HeroSection() {
  const [current, setCurrent] = useState(2);
  const [titleReady, setTitleReady] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const t = setTimeout(() => setTitleReady(true), 300);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5500);
    return () => {
      clearTimeout(t);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return (
    <section className="relative min-h-screen w-full overflow-hidden grain-overlay">
      <div className="absolute inset-0 z-0">
        {slides.map((slide, i) =>
        <div key={i} className={`carousel-slide ${i === current ? 'active' : ''}`}>
            <AppImage
            src={slide.src}
            alt={slide.alt}
            fill
            priority={i === 2}
            sizes="100vw"
            className="object-cover" />
          
          </div>
        )}
      </div>

      <div className="absolute inset-0 z-10 bg-gradient-to-t from-black/80 via-black/50 to-black/30 pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-full md:w-80 z-10 bg-black/40 pointer-events-none hidden md:block" />

      <div className="relative z-20 min-h-screen grid grid-cols-1 md:grid-cols-12 pt-20">
        <div className="col-span-1 md:col-span-9 flex flex-col justify-end p-5 sm:p-8 md:p-14 pb-10 sm:pb-14 md:pb-20">
          <div
            className={`mb-4 sm:mb-6 flex items-center gap-3 transition-all duration-700 ${
            titleReady ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`
            }>
            
            <div className="w-8 h-0.5 bg-primary" />
            <span className="text-xs font-semibold tracking-widest uppercase text-white/70 font-mono">
              Беларусь · Все типы фундаментов для частных застройщиков
            </span>
          </div>

          <h1
            className={`text-reveal-wrapper-parent mb-4 sm:mb-6 ${titleReady ? 'reveal-active' : ''}`}>
            
            <div className="text-reveal-wrapper">
              <span
                className="text-reveal-content delay-200 block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tighter text-white leading-none">
                
                Заливка
              </span>
            </div>
            <div className="text-reveal-wrapper">
              <span
                className="text-reveal-content delay-300 block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tighter leading-none"
                style={{ color: 'var(--primary)' }}>
                
                Фундамента
              </span>
            </div>
            <div className="text-reveal-wrapper">
              <span
                className="text-reveal-content delay-400 block text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold tracking-tighter text-white leading-none">
                
                под ключ
              </span>
            </div>
          </h1>

          <p
            className={`text-white/75 text-base sm:text-lg md:text-xl max-w-xl leading-relaxed mb-7 sm:mb-10 transition-all duration-700 delay-500 ${
            titleReady ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`
            }>
            
            Свайно-ростверковый и плитный фундамент, перекрытия — любые бетонные работы для частных застройщиков. Гарантия качества на каждый объект.
          </p>

          <div
            className={`flex flex-col xs:flex-row items-stretch xs:items-center gap-3 sm:gap-4 transition-all duration-700 delay-700 ${
            titleReady ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`
            }>
            
            <button
              onClick={() => {
                const el = document.querySelector('#contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center justify-center gap-2 bg-primary text-white px-6 sm:px-7 py-3.5 sm:py-4 rounded-xl font-semibold text-sm sm:text-base hover:bg-accent transition-all duration-300 shadow-lg btn-pulse">
              
              Оставить заявку
              <Icon name="ArrowRightIcon" size={18} />
            </button>
            <button
              onClick={() => {
                const el = document.querySelector('#calculator');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center justify-center gap-2 text-white border border-white/40 px-6 sm:px-7 py-3.5 sm:py-4 rounded-xl font-semibold text-sm sm:text-base hover:bg-white/10 transition-all duration-300 backdrop-blur-sm">
              
              Рассчитать объём
              <Icon name="CalculatorIcon" size={18} />
            </button>
          </div>

          <div className="flex gap-2 mt-7 sm:mt-10">
            {slides.map((_, i) =>
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`rounded-full transition-all duration-300 ${
              i === current ? 'w-8 h-2 bg-primary' : 'w-2 h-2 bg-white/40'}`
              }
              aria-label={`Слайд ${i + 1}`} />

            )}
          </div>
        </div>

        <div className="col-span-1 md:col-span-3 flex flex-row md:flex-col border-t md:border-t-0 md:border-l border-white/20">
          {stats.map((stat, i) =>
          <div
            key={i}
            className={`flex-1 p-4 sm:p-6 md:p-8 flex flex-col justify-between border-r last:border-r-0 md:border-r-0 md:border-b last:md:border-b-0 border-white/20 group hover:bg-white/10 transition-colors duration-300 reveal active delay-${(i + 3) * 100}`}>
            
              <Icon
              name={stat.icon as Parameters<typeof Icon>[0]['name']}
              size={24}
              className="text-primary mb-3 hidden md:block" />
            
              <div>
                <p className="text-2xl sm:text-3xl md:text-4xl font-bold text-white tracking-tighter leading-none">
                  {stat.value}
                </p>
                <p className="text-xs font-mono text-white/50 mt-1 tracking-wider leading-tight">
                  {stat.label}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 hidden md:flex flex-col items-center gap-2 opacity-50">
        <div className="w-0.5 h-8 bg-white animate-bounce" />
        <span className="text-white text-xs tracking-widest font-mono uppercase">Листать</span>
      </div>
    </section>);

}